import script from "./IssuePointSelectForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./IssuePointSelectForm.vue?vue&type=script&setup=true&lang=ts"

import "./IssuePointSelectForm.vue?vue&type=style&index=0&id=caf15ac8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caf15ac8"]])

export default __exports__